// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__ANdA0","Circle":"Loader_Circle__Vzz5E","rotate":"Loader_rotate__3fyxQ","One":"Loader_One__2EbeA","Two":"Loader_Two__1Sh6N","Three":"Loader_Three__EwNwt"};